import { BehaviorSubject } from 'rxjs';
import { SimpleConfigObservable } from './simpleConfigObservable';
import { Gettable } from './configAttributeInterfaces';

export class SimpleConfigObservableWithValue<T1, T2>
  extends SimpleConfigObservable<T1, T2>
  implements Gettable<T1, T2> {

  protected _source: BehaviorSubject<null | T2>;

  constructor(
    context: T1,
    protected _default: null | T2 = null,
    value: null | T2 = null,
  ) {
    super(context);
    this._source = new BehaviorSubject<null | T2>((value == null) ? this._default : value);
  }

  public get(): null | T2 {
    return this._source.getValue();
  }

  public trigger(): T1 {
    return this.set(this.get());
  }

  public set(value: null | T2 = null): T1 {
    return super.set((value == null) ? this._default : value);
  }

}
